import React from 'react';

import { SurveyButton } from '../../Survey/SurveyButton';
import { SurveyContainer } from '../../Survey/SurveyContainer';
import { SurveyParagraph } from '../../Survey/SurveyParagraph';
import { SurveyTitle } from '../../Survey/SurveyTitle';
import { SurveyWrapper } from '../../Survey/SurveyWrapper';
import './OnboardingIntro.scss';

interface OnboardingIntroProps {
  isReactivation: boolean;
  onStartNow: () => void;
}

export const OnboardingIntro: React.FC<OnboardingIntroProps> = ({ isReactivation, onStartNow }) => {
  return (
    <div className="onboarding-intro onboarding-survey-container">
      <SurveyContainer>
        <SurveyWrapper>
          <div className="onboarding-intro-page">
            <SurveyTitle>
              {isReactivation ? 'Welcome back to Every Mother' : 'Welcome to Every Mother'}
            </SurveyTitle>
            <hr />

            {isReactivation ? (
              <SurveyParagraph>We’re excited to join you through this journey!</SurveyParagraph>
            ) : (
              <SurveyParagraph>We&apos;re glad to be part of your health journey.</SurveyParagraph>
            )}

            {isReactivation ? (
              <SurveyParagraph>
                Things may have changed since you were last here. Let&apos;s start by answering some
                questions that will help us build your customized exercise plan.
              </SurveyParagraph>
            ) : (
              <SurveyParagraph>
                Tell us about yourself to help us create your personalized exercise plan.
              </SurveyParagraph>
            )}

            <SurveyButton className="survey-primary-btn" onClick={onStartNow}>
              Start Now
            </SurveyButton>
          </div>
        </SurveyWrapper>
      </SurveyContainer>
    </div>
  );
};
